export default {
    loading : false,
    params: {
        pending_dispatch_order : null,
        date: null
    },
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    },
    report_data:[],
    document_products: []
}



// WEBPACK FOOTER //
// ./src/modules/report-document-pending-dispatch-order/state.js